<script>

</script>

<style>
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .hud{
    height: 80px;
    width: 80px;
    position: relative;
  }
  .loading_logo {
    height: 32px;
    position: absolute;
    right: 25px;
    top: 25px;
  }
  .loading_indicator{
    border-radius: 80px;
    width: 80px;
    height: 80px;
    display: block;
    position: absolute;
    -webkit-animation: rotating 1.7s cubic-bezier(0.22, 0.8, 0.81, 0.46) infinite;
    -moz-animation: rotating 1.7s cubic-bezier(0.22, 0.8, 0.81, 0.46) infinite;
    -ms-animation: rotating 1.7s cubic-bezier(0.22, 0.8, 0.81, 0.46) infinite;
    -o-animation: rotating 1.7s cubic-bezier(0.22, 0.8, 0.81, 0.46) infinite;
    animation: rotating 1.7s cubic-bezier(0.22, 0.8, 0.81, 0.46) infinite;
  }
</style>
<div class="hud">
  <img class="loading_indicator" src="/assets/img/loading_circle.png">
  <img class="loading_logo" src="/assets/img/iso_small.png">
</div>
